export default __webpack_public_path__ + "static/media/overview-active.e272c184.svg";